/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */

// 资质状态 certificationStatus
export const CERTIFICATION_STATUS = {
  0: { label: '未上传', value: '0' },
  1: { label: '待审核', value: '1' },
  2: { label: '服务商审核通过', value: '2' },
  3: { label: '服务商审核不通过', value: '3' },
  4: { label: '平台审核通过', value: '4' },
  5: { label: '平台审核不通过', value: '5' }
};
// 入驻状态 inStatus
export const IN_STATUS = {
  0: { label: '未入驻', value: '0' },
  1: { label: '已入驻', value: '1' },
  2: { label: '已退出', value: '2' },
  3: { label: '不可入驻', value: '3' }
};
// 支付通道状态 payStatus
export const OPEN_STATUS_MAPPING = {
  1: { label: '未开通', value: '1' },
  2: { label: '开通中', value: '2' },
  3: { label: '开通成功', value: '3' },
  4: { label: '开通失败', value: '4' }
};
// 实名认证状态 userAuthStatus
export const USER_AUTH_STATUS = {
  1: { label: '已实名', value: '1' },
  2: { label: '未实名', value: '2' }
};
// 职业认证状态 OccupationAuthStatus
export const OCCUPTION_AUTH_STATUS = {
  1: { label: '未认证', value: '1' },
  2: { label: '已认证', value: '2' }
  // 2: { label: '已认证', value: '2' }
};

// 项目执行状态 projectStatus
export const PROJECT_STATUS = {
  1: { label: '未发起', value: '1' },
  2: { label: '未开始', value: '2' },
  3: { label: '进行中', value: '3' },
  4: { label: '已暂停', value: '4' },
  5: { label: '已完结', value: '5' }
};

// 企业签约状态 signStatus
export const SIGN_STATUS = {
  0: { label: '未签约', value: '0' },
  1: { label: '签约中', value: '1' },
  2: { label: '已签署', value: '2' },
  3: { label: '签署失败', value: '3' }
};

export const AUDITOR_MAPPING = {
  1: { label: '服务商待审核', value: '1' },
  2: { label: '平台待审核', value: '2' }
};

//用户状态,1启用,2停用,3已注销
export const ENABLED_STATUS = {
  1: { label: '已启用', value: 1 },
  2: { label: '已停用', value: 2 },
  3: { label: '已注销', value: 3 }
};

//入驻状态,1未入驻,2已入驻,3拒绝入驻,4已退出
export const SETTLED_STATUS = {
  1: { label: '未入驻', value: 1 },
  2: { label: '已入驻', value: 2 },
  3: { label: '拒绝入驻', value: 3 },
  4: { label: '已退出', value: 4 }
};

//结算状态,1未结算,2已结算,3结算中
export const SETTLEMENT_ACTIVITY_STATUS = {
  1: { label: '未结算', value: 1 },
  2: { label: '已结算', value: 2 },
  3: { label: '结算中', value: 3 }
};

// 费用类型
export const ORDER_PRICE_TYPE = {
  1: { label: '项目服务费', value: 1 },
  2: { label: '综合服务费', value: 2 }
};

// 支付方式
export const PAY_TYPE = {
  1: { label: '线上支付', value: 1 },
  2: { label: '线下支付', value: 2 }
};
// 支付状态
export const ORDER_PAY_STATUS = {
  '0': { label: '待支付', value: '0' },
  '1': { label: '支付中', value: '1' },
  '2': { label: '部分支付成功', value: '2' },
  '3': { label: '支付成功', value: '3' },
  '4': { label: '支付失败', value: '4' }
};
// 支付状态
export const ORDER_PAY_STATUS_PAY_SUCCESS = {
  '0': { label: '待支付', value: '0' },
  '1': { label: '支付中', value: '1' },
  '2': { label: '支付成功', value: '2' },
  '3': { label: '支付失败', value: '3' }
};
// 终端服务人员类型
export const TERMINAL_TYPE = {
  1: { label: '自然人', value: 1 },
  3: { label: '个体工商户', value: 3 }
};
